<template>
  <div>
    <Header />
    
    <section class="main-content columns is-fullheight">
			 <aside class="column is-2 aside hero is-fullheight">
            <div>
               
                <div class="main">
                  <p class="menu-label">
                    General
                  </p>
                  <ul class="menu-list">
                    <li><router-link to="/"  class="item ">Home</router-link></li>
                    
                  </ul>

                    <div v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('admin'))">
                   <p class="menu-label">
                    Contacts
                  </p>
                  <ul class="menu-list">
                    <li><router-link to="/contacts"  class="item ">Search</router-link></li>
                    <li><router-link to="/contacts/add"  class="item ">Add New</router-link></li>
                    <li><router-link to="/contacts/new"  class="item ">Merge Applications</router-link></li>
                    
                  </ul>
                  </div>

                  <p class="menu-label">
                    Applications
                  </p>
                  <ul class="menu-list">
                    <li v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('officer') || $auth.user.roles.includes('admin'))"><router-link to="/applications/status/new"  class="item " >New Applications</router-link></li>
                    <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('officer'))"><router-link to="/applications/status/officer-completed" class="item"  >Completed Applications</router-link></li>
                    <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('officer'))"><router-link to="/applications/status/awarded" class="item" >Awarded Applications</router-link></li>
                    
                    <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin'))"><router-link to="/applications/status/endorsed" class="item" >Endorsed Applications</router-link></li>
                    <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin'))"><router-link to="/applications/status/non-endorsed" class="item" >Non-Endorsed Applications</router-link></li>
                     <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin'))"><router-link to="/applications/status/awarded" class="item" >Awarded Applications</router-link></li>
                     <li v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin') || $auth.user.roles.includes('director'))"><router-link to="/applications/overview" class="item"  target="_blank">Print Overview</router-link></li>
                    
                    
                   <li v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('admin'))"> <router-link to="/governing_bodies"  class="item " >Governing Bodies</router-link></li>
                    
                    
                    
                    <li><router-link to="/applications" class="item" v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin1'))">200 Club</router-link></li>
                    <li><router-link to="/applications" class="item" v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin1'))">Reporting</router-link></li>
                   <li> <router-link to="/applications" class="item" v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin1'))">Config</router-link></li>
                  </ul>
                 
                  
                    
                   
                    
                    <router-link to="/people" class="item " v-if="!$auth.loading && $auth.isAuthenticated && ( $auth.user.roles.includes('admin1'))"><span class="icon"><i class="fa fa-users"></i></span><span class="name">People</span></router-link>
                    

                  <div v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('admin'))">
                    <p class="menu-label">
                      Reports
                    </p>
                    <ul class="menu-list">
                      <li><router-link to="/reports/applications_by_council_area"  class="item ">Council Areas</router-link></li>
                      <li><router-link to="/reports/funded_athletes_contact_details"  class="item ">Funded Athletes List</router-link></li>
                      <li><router-link to="/reports/athletes_breakdown"  class="item ">Athletes Breakdown</router-link></li>
                      
                    </ul>
                  </div>

                  <div v-if="!$auth.loading && $auth.isAuthenticated && ($auth.user.roles.includes('admin'))">
                   <p class="menu-label">
                    Users
                  </p>
                  <ul class="menu-list">
                    <li><router-link to="/users"  class="item ">Show All Users</router-link></li>
                    
                  </ul>
                  </div>

                    <div v-if="!$auth.loading">
                      <p class="menu-label">
                      When You're Done
                    </p>
                    <ul class="menu-list">
                      <li>
                    <a v-if="$auth.isAuthenticated" @click="logout" class="item">Logout</a>

                      </li>
                      
                    </ul>
                    <!-- show logout when authenticated -->
                    
                     </div>
                </div>
            </div>
        </aside>

  
		<div class=" column is-10">
			<div class="section pt-5">
				<router-view/>
			
			
			</div>
		</div>
		</section>
    
    
  </div>
</template>

<style scoped src="@/assets/css/inbox.css">
  
</style>

<script>
import Header from '@/components/Header.vue'
export default {
  name: 'Default',
  components: {
    Header,
  },
   methods: {
	  // Log the user in
	  login() {
	    this.$auth.loginWithRedirect();
	  },
	  // Log the user out
	  logout() {
	    this.$auth.logout({
	      returnTo: window.location.origin
	    });
	  }
  },data: function() {
        return {
            
        }
    },
    watch: {
	    '$route' () {
	      
	    }
    },
    computed: {
      officeruser: function() {
        if(this.$auth.loading === 1)
        {
          return this.$auth.isAuthenticated && (this.$auth.user.roles.includes('officer') || this.$auth.user.roles.includes('admin'))
        }
        else{
          return 0
        }
      }
    }
}
</script>